import { useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export function useVisitorId() {
    const [visitorId, setVisitorId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getId = async () => {
            // 1. 尝试从本地存储获取
            const cachedId = localStorage.getItem('fp_visitor_id');

            if (cachedId) {
                setVisitorId(cachedId);
                setIsLoading(false);
                return; // 直接结束，不再执行复杂的计算
            }

            // 2. 如果缓存没有，再执行 FingerprintJS
            try {
                console.time('fp_calculation'); // 性能监控
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                const newId = result.visitorId;

                // 3. 存入缓存
                localStorage.setItem('fp_visitor_id', newId);
                setVisitorId(newId);
                console.timeEnd('fp_calculation');
            } catch (e) {
                console.error("生成指纹失败", e);
            } finally {
                setIsLoading(false);
            }
        };

        getId();
    }, []);

    return { visitorId, isLoading };
}